import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    getEventsCatalogAsync,
    getSystemFieldsAsync,
    getTrackerEventsAsync,
} from "../../../../redux/slices/trackerEvents/trackerEvents.asyncActions";
import { getExcistTrackersRedux } from "../../../../redux/slices/trackers/trackers.asyncActions";
import TrackerEventMappingForm from "./TrackerEventMappingForm.layout";
import {
    TrackerEventMappingFormDispatchProps,
    TrackerEventMappingFormStateProps,
} from "./TrackerEventMappingForm.types";

const mapStateToProps = (state: any): TrackerEventMappingFormStateProps => ({
    language: state.languagesState.languages,
    trackerEvents: state.trackerEvents.trackerEvents,
    eventsCatalog: state.trackerEvents.eventsCatalog,
    filtersCatalog: state.trackerEvents.filtersCatalog,
    systemFields: state.trackerEvents.systemFields,
    isLoadingTrackerEvents: state.trackerEvents.isLoadingTrackerEvents,
    trackers: state.allTrackersState.trackers,
});

const mapDispatchToProps = (
    dispatch: any,
): TrackerEventMappingFormDispatchProps => ({
    dispatchGetTrackerEvents: () => dispatch(getTrackerEventsAsync()),
    dispatchGetEventsCatalog: () => dispatch(getEventsCatalogAsync()),
    dispatchGetSystemFields: () => dispatch(getSystemFieldsAsync()),
    dispatchGetTrackers: () => dispatch(getExcistTrackersRedux()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(TrackerEventMappingForm);
